import { render, staticRenderFns } from "./importPayrollData.vue?vue&type=template&id=5aaf6c88&scoped=true&"
import script from "./importPayrollData.vue?vue&type=script&lang=js&"
export * from "./importPayrollData.vue?vue&type=script&lang=js&"
import style0 from "./importPayrollData.vue?vue&type=style&index=0&id=5aaf6c88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf6c88",
  null
  
)

export default component.exports